module.exports = __webpack_public_path__ + "media/images/lb/086-c4e76df65d4e330e1ed52c7b404bbdba.svg";